import React from "react";
import cx from "classnames";
import { Reveal } from "src/components/reveal";
import { Media } from "src/components/media";
import { Container } from "src/components/container";

import { ReactComponent as SustainabilityPageShape1 } from "src/images/svg/SustainabilityPageShape1.svg";
import { ReactComponent as SustainabilityPageShape2 } from "src/images/svg/SustainabilityPageShape2.svg";
import { ReactComponent as SustainabilityPageShape3 } from "src/images/svg/SustainabilityPageShape3.svg";
import { ReactComponent as ArrowRight } from "src/images/svg/ArrowRight.svg";

import * as styles from "./what.module.css";

const masks = [
	SustainabilityPageShape1,
	SustainabilityPageShape2,
	SustainabilityPageShape3,
];

interface SectionInterface {
	_key: string;
	title: string;
	bulletPoints: string[];
	media: {
		image: {
			alt: string;
			asset: any;
		};
		video?: any;
	};
}

const Section = ({
	data,
	index,
}: {
	data: SectionInterface;
	index: number;
}) => {
	const Mask = masks[index];

	return (
		<Reveal className={styles.section}>
			<Container>
				<div className={styles.sectionInner}>
					<div className={styles.sectionContent}>
						<h3 className={cx("title")}>{data.title}</h3>
						{data.bulletPoints && (
							<ul className={styles.pointsList}>
								{data.bulletPoints.map((point, index) => (
									<li key={index} className={styles.pointsItem}>
										<ArrowRight className={styles.pointsItemArrow} />
										<p className={cx("body", styles.pointsItemCopy)}>{point}</p>
									</li>
								))}
							</ul>
						)}
					</div>
					<div className={styles.mediaContainer}>
						<div
							className={cx(
								styles.mediaShape,
								styles[`mediaShape${index + 1}`]
							)}
						>
							<Mask />
							<Media data={data.media} className={styles.mediaShapeMedia} />
						</div>
					</div>
				</div>
			</Container>
		</Reveal>
	);
};

export interface SustainabilityWhatProps {
	sections: [SectionInterface];
}

export const SustainabilityWhat = ({
	data,
}: {
	data: SustainabilityWhatProps;
}) => {
	const { sections } = data;

	return (
		<div>
			{sections && (
				<div>
					{sections.map((section, index) => (
						<Section data={section} index={index} key={section._key} />
					))}
				</div>
			)}
		</div>
	);
};
